import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import MainContent from "./MainContent";

const Home = () => (
  <>
    <Header />
    <MainContent />
    <Footer />
  </>
);

export default Home;
